import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// TODO: deprecate
export const useCustomerData = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    return state.context.currentCustomer;
  });
};
